import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { OnboardingLayout } from "@layouts/OnboardingLayout";
import Logo from "@shared/Logo";
import { Modal } from "@shared/controls/Modal";
import GetMeta from "@pages/SeoPages/GetMeta";
import { accountTypes } from "../../constants/accountTypes";

export const AccountSelection = () => {
  const [type, setType] = useState("");
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const handleBack = () => {
    setShowModal(false);
    setType("");
  };

  const handleCardSelect = (id: string) => {
    if (id === "seller") {
      setShowModal(true);
    } else {
      setType(id);
    }
  };

  const handleSubmit = (e?: any) => {
    if (e) e.preventDefault();
    if (showModal) {
      if (type === "seller" || type === "agent") {
        setShowModal(false);
        navigate(`/get-started/${type}`);
        return;
      }
    }
    if (type) navigate(`/get-started/${type}`);
  };

  return (
    <OnboardingLayout>
      <GetMeta
        description="Start your journey to home ownership or selling success! connect with our expert agents."
        title={`Get Started | Krent Inc`}
        canonicalValue={"terms"}
      />
      <div className="container py-4" style={{ maxWidth: 480 }}>
        <h3
          className="fw-bolder mb-4 text-black"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <Logo />
        </h3>

        <h4 className="fw-bolder font-onest mb-1">Select account type</h4>
        <p className="text-muted fs-14 mb-4 font-onest">
          Let us know what you'll be using Krent for so we can optimize your
          experience.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-column gap-3 mb-4">
            {accountTypes.map((account) => {
              const isSelected =
                type === account.id ||
                (account.id === "seller" &&
                  (type === "seller" ||
                    type === "agent" ||
                    type === "property-manager"));

              return (
                <div
                  key={account.id}
                  onClick={() => handleCardSelect(account.id)}
                  className="d-flex align-items-start gap-3 p-3 rounded-4"
                  style={{
                    border: `1.5px solid ${isSelected ? "#1a7a5e" : "#e0e0e0"}`,
                    cursor: "pointer",
                    background: isSelected ? "#f0faf6" : "#fff",
                    transition: "border-color 0.2s, background 0.2s",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
                    style={{
                      width: 30,
                      height: 48,
                    }}
                  >
                    {account.icon}
                  </div>
                  <div>
                    <h6 className="fw-bold font-onest mb-1">{account.label}</h6>
                    <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                      {account.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            type="submit"
            className="btn w-full fw-semibold"
            disabled={!type}
            style={{
              background: type ? "#47BBA9" : "#ccc",
              color: "#fff",
              borderRadius: 8,
              padding: "10px 0",
              border: "none",
              transition: "background 0.2s",
            }}
          >
            Proceed
          </button>
        </form>

        <div className="text-center mt-4">
          <p className="mb-0 font-onest" style={{ fontSize: "14px" }}>
            Have a Krent account?{" "}
            <span
              onClick={() => navigate("/sign-in")}
              style={{
                color: "#47BBA9",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "600",
              }}
            >
              Sign in here
            </span>
          </p>
        </div>

        {showModal && (
          <Modal
            show={showModal}
            onClose={() => setShowModal(false)}
            dismissible={false}
          >
            <div className="px-3 py-2">
              <h6 className="fw-bold fs-5 mb-4">
                Are you an Agent or Property Owner?
              </h6>

              {[
                { value: "agent", label: "Agent" },
                { value: "seller", label: "Property Owner" },
                { value: "property-manager", label: "Property Manager" },
              ].map((opt) => (
                <div
                  key={opt.value}
                  onClick={() => setType(opt.value)}
                  className="d-flex align-items-center gap-3 p-3 rounded-3 mb-3"
                  style={{
                    border: `1.5px solid ${type === opt.value ? "#1a7a5e" : "#e0e0e0"}`,
                    cursor: "pointer",
                    background: type === opt.value ? "#f0faf6" : "#fff",
                    transition: "border-color 0.2s, background 0.2s",
                  }}
                >
                  <div
                    className="rounded-circle border flex-shrink-0"
                    style={{
                      width: 18,
                      height: 18,
                      borderColor: type === opt.value ? "#1a7a5e" : "#aaa",
                      borderWidth: 2,
                      borderStyle: "solid",
                      background:
                        type === opt.value ? "#1a7a5e" : "transparent",
                    }}
                  />
                  <span className="fw-semibold">{opt.label}</span>
                </div>
              ))}

              <div className="d-flex flex-column gap-2 mt-4">
                <button
                  className="btn w-100 fw-semibold"
                  onClick={handleSubmit}
                  style={{
                    background: "#1a7a5e",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 0",
                  }}
                >
                  Continue
                </button>
                <button
                  className="btn w-100 fw-semibold"
                  onClick={handleBack}
                  style={{
                    border: "1.5px solid #1a7a5e",
                    color: "#1a7a5e",
                    borderRadius: 8,
                    padding: "10px 0",
                    background: "transparent",
                  }}
                >
                  Go Back
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </OnboardingLayout>
  );
};
